import { FC } from 'react'
import Icon from './Icon'
import TextContent from './TextContent'

interface Props {
  title?: string
  desc?: string[]
  metricLabel?: string
  metricValue?: string
  trend?: string
  trendText?: string
}

const MetricDetails: FC<Props> = props => {
  const iconColor =
    props.trend === 'equal'
      ? 'text-grey'
      : props.trend === 'down'
      ? 'text-red'
      : 'text-green'
  const desc = <TextContent content={props.desc} />

  return (
    <div className="text-black">
      <h3 className="mb-4 text-black type-heading-four">{props.title}</h3>
      <div className="mb-6 text-slate">{desc}</div>
      <div className="py-4 px-6 bg-gray-light md:display-inline-block">
        <div className="mb-1 type-heading-five uppercase text-crop-none">
          {props.metricLabel}
        </div>
        <div className="mb-1 text-blue-mid text-3xl">{props.metricValue}</div>
        <div>
          {props.trend && (
            <Icon
              variant={`caret-${props.trend as 'up' | 'down'}`}
              className={`Icon--xs mr-2 ${iconColor}`}
              style={{ verticalAlign: 'text-top', lineHeight: 1.5 }}
            />
          )}
          {props.trendText}
        </div>
      </div>
    </div>
  )
}

export default MetricDetails
